import { prop, define } from "@/components/builder/utils";

import BasePreview from "../../base";

function UnsubscribeFormAlertPreview({ ...props }) {
  return <BasePreview {...props}>
    <p>
      Ops.. User not found.
    </p>
  </BasePreview>
}

function UnsubscribeFormAlertHTML({ attributes }) {
  return <>
    {`{{#if (or @params.email @params.uid @params.i) }}`}
      {`{{#if error}}`}
        <div role="alert" {...attributes}>
          {`Ops.. {{error}}.`}
          <button type="button" className="absolute top-0 right-0 cursor-pointer" data-dismiss="alert" aria-label="Close">
            <span className="p-1" aria-hidden="true">&times;</span>
          </button>
        </div>
      {`{{/if}}`}
      {`{{#if (not found)}}`}
        <div role="alert" {...attributes}>
          Ops.. User not found.
          <button type="button" className="absolute top-0 right-0 cursor-pointer" data-dismiss="alert" aria-label="Close">
            <span className="p-1" aria-hidden="true">&times;</span>
          </button>
        </div>
      {`{{/if}}`}
    {`{{/if}}`}
  </>
}

export default define('unsub-form-alert', UnsubscribeFormAlertPreview, UnsubscribeFormAlertHTML)
  .property(...prop.predefined.typography())
  .property(...prop.predefined.borders())
  .property(...prop.predefined.appearance())
  .property(prop.predefined.letterSpacing())
  .property(prop.predefined.lineHeight())
  .property(prop.predefined.textAlign())
  .property(prop.predefined.textShadow())
  .defaultProps({
    textAlign: { horizontal: 'center' },
    fontSize: 'base',
    textColor: 'gray-900',
    outline: {
      outline: 'none',
    },
    size: { width: 'w-full' },
  })
  .build()
